import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "../ui/button";
import instagramIcon from "@/assets/instagram.svg";
import { openInstagramProfile } from "@/lib/openExternal";

export default function FollowUsButton() {
  const t = useTranslation();

  return (
    <Button
      variant="outline"
      className="p-8 pl-7 rounded-3xl items-center border border-zinc-600"
      onClick={() => openInstagramProfile("pulsedating")}
    >
      <img src={instagramIcon} className="w-6 h-6 mr-3" />
      {t.APPLIED_PAGE.FOLLOW_US_BUTTON}
    </Button>
  );
}
